<script>
  import SelecaoBusca from './SelecaoBusca.vue';
  import RateioProjetos from './RateioProjetos.vue';
  import AnexosOperacao from './AnexosOperacao.vue';

  export function novaOrigemTransferencia(valor) {
    return {
      idConta: 0, nomeConta: '',
      valor: valor > 0 ? valor : 0,
      valorTexto: '',
      observacao: '', observacaoSugerida: '',
      rateiosDebito: [], rateiosCredito: [],
      semRateioDebito: false, semRateioCredito: false,
      anexos: [],
    };
  }

  export default {
    components: { SelecaoBusca, RateioProjetos, AnexosOperacao },
    props: {
      value: { type: Array, required: true },
      idContaCript: { type: String, required: true },
      idContaExtrato: { type: Number, default: 0 },
      total: { type: Number, default: 0 },
      creditoNoExtrato: { type: Boolean, default: true },
      nomeContaExtrato: { type: String, default: 'conta do extrato' },
      comRateio: { type: Boolean, default: true },
      comItem: { type: Boolean, default: false },
      consultarItem: { type: Boolean, default: false },
      validar: { type: Boolean, default: false },
      titulo: { type: String, default: 'Conta da outra ponta' },
      comObservacao: { type: Boolean, default: false },
      buscar: { type: Function, required: true },
      anexo: { type: Object, default: null },
    },
    computed: {
      multi() { return this.value.length > 1; },
      observacaoPorConta() { return this.comObservacao && this.multi; },
      distribuido() {
        return this.arredondar(this.value.reduce((soma, o) => soma + (+o.valor || 0), 0));
      },
      saldo() { return this.arredondar(this.total - this.distribuido); },
      fechou() { return Math.abs(this.saldo) < 0.005; },
      contasRepetidas() {
        const ids = this.value.filter(o => o.idConta > 0).map(o => o.idConta);
        return ids.some((id, i) => ids.indexOf(id) !== i);
      },
      mensagem() {
        if (this.value.some(o => !(o.idConta > 0))) return 'Selecione a conta de cada linha.';
        if (this.contasRepetidas) return 'A mesma conta aparece em duas linhas — junte os valores numa linha só.';
        if (this.value.some(o => !((+o.valor || 0) > 0))) return 'O valor de cada conta precisa ser maior que zero.';
        if (!this.fechou)
          return this.saldo > 0
            ? 'Falta distribuir ' + this.formatar(this.saldo) + ' entre as contas.'
            : 'As contas passaram ' + this.formatar(-this.saldo) + ' do valor do extrato.';
        if (this.comRateio && this.value.some(o => !this.rateiosDaOrigemValidos(o))) return 'Complete o rateio das contas.';
        if (this.observacaoPorConta && this.value.some(o => !(o.observacao || '').trim()))
          return 'Informe a observação de cada conta.';
        return '';
      },
      valido() { return this.mensagem === ''; },
    },
    watch: {
      valido: {
        immediate: true,
        handler(v) { this.$emit('valido', v); },
      },
      total() {
        if (this.value.length === 1) this.definirValor(this.value[0], this.total);
      },
      'value.length'() {
        if (this.value.length === 1) this.definirValor(this.value[0], this.total);
      },
    },
    mounted() {
      if (this.value.length === 0) this.adicionar();
      else if (this.value.length === 1) this.definirValor(this.value[0], this.total);
    },
    methods: {
      novaOrigem(valor) {
        const origem = novaOrigemTransferencia(this.arredondar(valor));
        origem.valorTexto = origem.valor > 0 ? this.formatar(origem.valor) : '';
        return origem;
      },
      adicionar() {
        this.$emit('input', this.value.concat([this.novaOrigem(this.saldo)]));
      },
      remover(indice) {
        const linhas = this.value.slice();
        linhas.splice(indice, 1);
        this.$emit('input', linhas);
      },
      idContaDebito(origem) { return this.creditoNoExtrato ? (origem.idConta || 0) : this.idContaExtrato; },
      idContaCredito(origem) { return this.creditoNoExtrato ? this.idContaExtrato : (origem.idConta || 0); },
      idAlvoDebito(origem) { return this.creditoNoExtrato ? (origem.idConta || 0) : 0; },
      idAlvoCredito(origem) { return this.creditoNoExtrato ? 0 : (origem.idConta || 0); },
      nomeContaDebito(origem) {
        return this.creditoNoExtrato ? (origem.nomeConta || 'outra conta') : this.nomeContaExtrato;
      },
      nomeContaCredito(origem) {
        return this.creditoNoExtrato ? this.nomeContaExtrato : (origem.nomeConta || 'outra conta');
      },
      rateiosDaOrigemValidos(origem) {
        const valor = this.arredondar(origem.valor);
        const debito = origem.semRateioDebito || this.rateioValido(origem.rateiosDebito, valor);
        const credito = origem.semRateioCredito || this.rateioValido(origem.rateiosCredito, valor);
        return debito && credito;
      },
      rateioValido(rateios, total) {
        const linhas = rateios || [];
        if (linhas.length === 0) return true;
        if (linhas.some(r => !(r.idProjeto > 0) || !(r.idRubrica > 0) || !(r.idSubRubrica > 0))) return false;
        if (this.comItem && linhas.some(r => r.exigeItem && !(r.idItem > 0))) return false;
        if (linhas.some(r => !((+r.valor || 0) > 0))) return false;

        const chaves = linhas.map(r => r.idProjeto + '-' + r.idRubrica + '-' + r.idSubRubrica +
                                       '-' + (this.comItem ? (r.idItem || 0) : 0));
        if (chaves.some((c, i) => chaves.indexOf(c) !== i)) return false;

        const soma = linhas.reduce((s, r) => s + (+r.valor || 0), 0);
        return Math.abs(this.arredondar(soma) - total) < 0.005;
      },
      aoEscolherConta(origem, opcao) {
        origem.nomeConta = opcao ? opcao.nome : '';
        this.$emit('conta-escolhida', { origem, opcao, indice: this.value.indexOf(origem) });
      },
      aoDigitarValor(origem, evento) {
        origem.valorTexto = evento.target.value;
        origem.valor = this.converter(evento.target.value);
      },
      aoSairDoValor(origem) {
        this.definirValor(origem, origem.valor);
      },
      usarSaldo(origem) {
        this.definirValor(origem, (+origem.valor || 0) + this.saldo);
      },
      definirValor(origem, valor) {
        const novo = this.arredondar(valor > 0 ? valor : 0);
        origem.valor = novo;
        origem.valorTexto = novo > 0 ? this.formatar(novo) : '';
        this.ajustarRateioUnico(origem.rateiosDebito, novo);
        this.ajustarRateioUnico(origem.rateiosCredito, novo);
      },
      ajustarRateioUnico(rateios, valor) {
        if (!rateios || rateios.length !== 1) return;
        rateios[0].valor = valor;
        rateios[0].valorTexto = valor > 0 ? this.formatar(valor) : '';
      },
      converter(texto) {
        const limpo = (texto || '').replace(/[^0-9,.-]/g, '').replace(/\./g, '').replace(',', '.');
        return this.arredondar(+limpo || 0);
      },
      arredondar(valor) { return Math.round((+valor || 0) * 100) / 100; },
      formatar(valor) {
        return (+valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
    },
  }
</script>

<template>
  <div class="og-bloco">
    <div class="og-topo" v-if="multi">
      <span class="og-titulo">{{ multi ? titulo + 's' : titulo }} <span class="og-obr">*</span></span>
      <span v-if="multi" class="og-resumo" :class="{ 'og-resumo-ok': fechou, 'og-resumo-falta': !fechou }">
        {{ formatar(distribuido) }} de {{ formatar(total) }}
        <template v-if="!fechou"> · falta {{ formatar(saldo) }}</template>
      </span>
    </div>

    <div v-for="(origem, indice) in value" :key="indice" class="og-item" :class="{ 'og-item-multi': multi }">
      <div v-if="multi" class="og-faixa">
        <span class="og-ordem">Conta {{ indice + 1 }} de {{ value.length }}</span>
        <button type="button" class="og-remover" @click="remover(indice)" title="Remover esta conta">
          <i class="fa fa-trash-o"></i>
        </button>
      </div>

      <div class="og-linha">
        <div class="og-campo og-campo-conta" :class="{ 'og-invalido': validar && !(origem.idConta > 0) }">
          <label v-if="!multi">{{ titulo }} <span class="og-obr">*</span></label>
          <selecao-busca v-model="origem.idConta" :texto="origem.nomeConta" :buscar="buscar"
                         placeholder="Buscar conta por nome, número ou banco..."
                         @selecionado="o => aoEscolherConta(origem, o)"></selecao-busca>
        </div>
        <div v-if="multi" class="og-campo og-campo-valor" :class="{ 'og-invalido': validar && !(origem.valor > 0) }">
          <label>Valor desta conta</label>
          <div class="og-valor-caixa">
            <input type="text" class="form-control og-valor" :value="origem.valorTexto"
                   @input="aoDigitarValor(origem, $event)" @blur="aoSairDoValor(origem)" placeholder="0,00">
            <button v-if="!fechou" type="button" class="og-saldo" @click="usarSaldo(origem)"
                    title="Jogar o que falta nesta conta"><i class="fa fa-level-down"></i></button>
          </div>
        </div>
      </div>

      <div v-if="observacaoPorConta" class="og-linha og-linha-obs">
        <div class="og-campo" :class="{ 'og-invalido': validar && !(origem.observacao || '').trim() }">
          <label>Observação desta conta <span class="og-obr">*</span></label>
          <input type="text" class="form-control" maxlength="300" v-model="origem.observacao"
                 placeholder="O que explicar a quem vai liberar esta transferência">
        </div>
      </div>

      <template v-if="comRateio">
        <rateio-projetos v-model="origem.rateiosDebito" :id-conta-cript="idContaCript" :total="origem.valor"
                         :id-conta-alvo="idAlvoDebito(origem)" natureza="D" :validar="validar"
                         :titulo="'Rateio do débito · ' + nomeContaDebito(origem)"
                         :desabilitado="creditoNoExtrato && !(origem.idConta > 0)"
                         :opcional="true" :com-item="comItem" :consultar-item="consultarItem"
                         aviso="Escolha a conta desta linha para informar o rateio do débito."
                         @sem-projetos="v => origem.semRateioDebito = v"></rateio-projetos>

        <rateio-projetos v-model="origem.rateiosCredito" :id-conta-cript="idContaCript" :total="origem.valor"
                         :id-conta-alvo="idAlvoCredito(origem)" natureza="C" :validar="validar"
                         :titulo="'Rateio do crédito · ' + nomeContaCredito(origem)"
                         :desabilitado="!creditoNoExtrato && !(origem.idConta > 0)"
                         :opcional="true" :com-item="comItem" :consultar-item="consultarItem"
                         aviso="Escolha a conta desta linha para informar o rateio do crédito."
                         @sem-projetos="v => origem.semRateioCredito = v"></rateio-projetos>
      </template>

      <div v-if="anexo" class="og-anexo">
        <anexos-operacao v-model="origem.anexos" :limite="anexo.limite || 0" :origens="anexo.origens || null"
                         :titulo="multi ? (anexo.titulo || 'Arquivos') + ' · conta ' + (indice + 1) : (anexo.titulo || 'Arquivos')"
                         :dica="anexo.dica || ''"></anexos-operacao>
      </div>
    </div>

    <div class="og-rodape">
      <button type="button" class="og-add" @click="adicionar">
        <i class="fa fa-plus"></i> {{ multi ? 'Adicionar outra conta' : 'Dividir entre mais contas' }}
      </button>
      <span v-if="validar && mensagem" class="og-msg">{{ mensagem }}</span>
    </div>
  </div>
</template>

<style scoped>
  .og-bloco { margin-top: 4px; }
  .og-topo { display: flex; align-items: baseline; justify-content: space-between; margin-bottom: 4px; }
  .og-titulo { font-size: 12px; font-weight: 600; color: #34495e; }
  .og-bloco .og-item-multi ~ .og-item-multi { margin-top: 12px; }
  .og-item-multi { border: 1px solid #dbe3ec; border-left: 3px solid #2f6fb2; border-radius: 6px; padding: 0 10px 10px; background: #fff; }
  .og-faixa { display: flex; align-items: center; justify-content: space-between; margin: 0 -10px 6px;
              padding: 5px 10px; background: #f2f6fa; border-bottom: 1px solid #e3e8ef;
              border-radius: 0 5px 0 0; }
  .og-ordem { font-size: 10px; text-transform: uppercase; letter-spacing: .04em; color: #64748b; font-weight: 600; }
  .og-remover { border: 0; background: none; color: #b0bac5; cursor: pointer; padding: 0 2px; }
  .og-remover:hover { color: #c0392b; }
  .og-linha { display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-end; }
  .og-linha-obs { margin-top: 8px; }
  .og-anexo { margin-top: 10px; }
  .og-campo { flex: 1 1 220px; min-width: 0; }
  .og-campo-valor { flex: 0 0 150px; }
  .og-campo label { display: block; font-size: 11px; color: #64748b; margin-bottom: 2px; font-weight: 600; }
  .og-obr { color: #c0392b; }
  .og-valor-caixa { position: relative; }
  .og-valor { text-align: right; padding-right: 22px; }
  .og-saldo { position: absolute; right: 3px; top: 50%; transform: translateY(-50%); border: 0; background: none;
              color: #8b97a5; padding: 0 2px; font-size: 11px; cursor: pointer; }
  .og-saldo:hover { color: #2f6fb2; }
  .og-invalido .form-control, .og-invalido >>> .form-control { border-color: #c0392b; background: #fdf6f5; }
  .og-invalido label { color: #c0392b; }
  .og-rodape { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-top: 8px; }
  .og-add { border: 1px solid #cfd8e3; background: #fff; border-radius: 3px; color: #2f6fb2;
            font-size: 11px; padding: 3px 9px; cursor: pointer; }
  .og-add:hover { border-color: #2f6fb2; }
  .og-msg { font-size: 11px; color: #c0392b; }
  .og-resumo { font-size: 11px; font-weight: 600; }
  .og-resumo-ok { color: #27865b; }
  .og-resumo-falta { color: #b9552c; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/OrigensTransferencia.vue